export const apiEndPoints = {

    HOME: 'page/home',
    ABOUT: 'page/about',
    CONTACT: 'page/contact',
    EQUIPMENTS: 'page/equipments',
    PROJECT: 'page/projects',
    PROJECT_DETAIL: 'project',
    CONTACT_FORM: 'contact-form-7/v1/contact-forms/014e80e/feedback',
    GET_IN_TOUCH_FORM: 'contact-form-7/v1/contact-forms/9bb2d43/feedback',
    FOOTER: 'custom/menu-footer',
};
